var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import BackBtn from '../../BackBtn';
import ReceivingScanInput from '../../receiving/ReceivingScanInput';
import { Row } from '../MoveControls';
var DestinationStep = function (_a) {
    var moveUnit = _a.moveUnit, quantityInput = _a.quantityInput, scanError = _a.scanError, focusSignal = _a.focusSignal, onScan = _a.onScan, onBack = _a.onBack;
    var t = useTranslation().t;
    return (_jsxs("div", { children: [_jsx(Row, { label: t('Moving'), value: moveUnit === null || moveUnit === void 0 ? void 0 : moveUnit.label }, void 0), ((moveUnit === null || moveUnit === void 0 ? void 0 : moveUnit.kind) === 'product' || (moveUnit === null || moveUnit === void 0 ? void 0 : moveUnit.kind) === 'asset') && (_jsx(Row, { label: t('Quantity'), value: quantityInput }, void 0)), _jsx("h2", __assign({ className: 'mb-2 mt-3 text-sm font-bold text-gray-700' }, { children: (moveUnit === null || moveUnit === void 0 ? void 0 : moveUnit.kind) === 'pallet' ? t('Scan New Location') : t('Scan New Location or Container') }), void 0), _jsx(ReceivingScanInput, { placeholder: ((moveUnit === null || moveUnit === void 0 ? void 0 : moveUnit.kind) === 'pallet'
                    ? t('Scan or enter a location')
                    : t('Scan a location or container')), showQtyInput: false, buttonLabel: t('Go'), errorText: scanError, focusSignal: focusSignal, onSubmit: function (scanId) { return onScan(scanId); } }, void 0), _jsx("div", __assign({ className: 'mt-4' }, { children: _jsx(BackBtn, { onClick: onBack, type: 'button' }, void 0) }), void 0)] }, void 0));
};
export default DestinationStep;
